/* eslint vars-on-top: 0 */
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { GdprActionsRepository, GdprReportsRepository } from 'common/repositories/index';


const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$rootScope', 'GdprActionsRestService', 'Util', 'GdprReportsRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.UserDataController
 *
 * @description
 * edit form for user details controller
 */
class UserDataController {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} GdprActionsRestService
     * @param  {any} Util
     * @param  {any} GdprReportsRestService
     */
    constructor(
        $scope, $state, $rootScope, GdprActionsRestService,
        Util, GdprReportsRestService,
    ) {

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.GdprActionsRestService = GdprActionsRestService;
        this.GdprReportsRestService = GdprReportsRestService;
        this.Util = Util;
        this.GdprReports = GdprReportsRepository.getAll();
        this.showGdprButton = CWCONFIG.features.showGdprButton;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        const gdprActionsObservable = GdprActionsRepository.getObservable();
        const onNextAction = (data) => {

            const dataReportRequested = data.find(action => action.attributes.action_type === 'gdpr_get_data');
            const maxDaysGdprReportDelivery = CWCONFIG.maxDaysGdprReportDelivery || 60;

            if (dataReportRequested) {

                const today = new Date();
                const requestDate = new Date(dataReportRequested.attributes.date_added);
                const timeDifference = Math.abs(today.getTime() - requestDate.getTime());
                const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

                /**
                If the no. of days passed since GDPR report was requested is less than configured
                no. of days for delivery, show pending message
                */
                if (daysDifference <= maxDaysGdprReportDelivery) {

                    this.$scope.dataReportPending = dataReportRequested.attributes.status === 'pending';
                    this.$scope.dataReportDate = moment(dataReportRequested.attributes.date_added).format('L');

                }

            }

        };

        const gdprActionsSubscriber =
            gdprActionsObservable.subscribe(onNextAction, () => { }, () => { });

        this.$scope.$on('$destroy', () => {

            gdprActionsSubscriber.dispose();

        });

        if (!this.$rootScope.gdprReportsLoaded) {

            // Used to display the loader in the gdpr report modal
            this.$rootScope.gdprReportsLoading = true;

            GdprReportsRestService.getAllAsync().then((response) => {

                if (response.data.data.length > 0) {

                    response.data.data.forEach((report) => {

                        const gdprReportTimestamp = Util.deepFind(report, 'attributes.request_received_timestamp');

                        if (gdprReportTimestamp) {

                            this.$rootScope.gdprReportTimestamp = moment(gdprReportTimestamp).format('L');

                        }

                        const finalReport = Util.deepFind(report, 'attributes.final_report');

                        if (finalReport) {

                            GdprReportsRepository.add(JSON.parse(finalReport));
                            this.$scope.hasReport = true;
                            this.$rootScope.gdprReportsLoaded = true;

                        }

                    });

                    this.$rootScope.gdprReportsLoading = false;

                } else {

                    this.$rootScope.gdprReportsLoading = false;
                    this.$scope.hasReport = false;

                }

            }).catch(() => {

                this.$rootScope.gdprReportsLoading = false;
                this.$scope.hasReport = false;

            });

        }
        if (this.GdprReports.length > 0) {

            this.$scope.hasReport = true;

        }

    }

    getReport() {

        const payload = {
            data: {
                attributes: {
                    action_type: 'gdpr_get_data',
                },
            },
        };

        Mixpanel.send('ConnectWeb Request Report Click');

        this.GdprActionsRestService.create(payload).then(() => {

            this.GdprActionsRestService.getAllAsync().then((response) => {

                GdprActionsRepository.replace(response.data.data);

            });

            this.$state.go('root.dashboard.my-account.ltb', {
                ltb: 'get-report',
            });

        }).then(null, (error) => {

            let errorReason;

            if (this.Util.deepFind(error, 'data.error')) {

                errorReason = error.data.code;

            } else if (this.Util.deepFind(error, 'data.errors')) {

                errorReason = error.data.errors[0].code;

            }

            if (errorReason === '1808') {

                Alert.error('cw.get_report.already_requested_error');

            } else {

                Alert.error('cw.get_report.error');

            }

        });

    }

    showReport() {

        this.$state.go('root.dashboard.my-account.ltb', {
            ltb: 'gdpr-report',
        });

    }

}

/**
     * @ngdoc directive
     * @name directives.UserDataDirective
     *
     * @description
     * edit form for user details directive
     */
class UserDataDirective {

    constructor() {

        this.template = require('./user-data.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, $state, $rootScope, GdprActionsRestService,
            Util, GdprReportsRestService,
        ) =>
            new UserDataController(
                $scope, $state, $rootScope, GdprActionsRestService,
                Util, GdprReportsRestService,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'userDataCtrl';

    }

}

_directiveDependencies.push(() => new UserDataDirective());


angular.module('directives')
    .directive('userData', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/data-settings/user-data/user-data.js